import { ReactNode } from "react";

export function Table({ children }: { children: ReactNode }) {
    return <div className="table-scroll rounded-2xl border border-rose-100 bg-white shadow-soft">{children}</div>;
}

export function THead({ children }: { children: ReactNode }) {
    return <thead className="bg-rose-50/80">{children}</thead>;
}

export function TH({ children }: { children: ReactNode }) {
    return <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">{children}</th>;
}

export function TD({ children }: { children: ReactNode }) {
    return <td className="px-4 py-3 text-sm text-gray-700">{children}</td>;
}